import { clearInvoice } from '../State/invoice'

export default () => async (dispatch) => {

  dispatch(clearInvoice())

}